import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { AzureBlobFSLocation } from 'app/model/dataset/location/azure-blobfs.location';
import { FileLocationAdapter } from './file-location.adapter';
import { IModel } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureBlobFSLocation)
})
export class AzureBlobFSLocationAdapter extends FileLocationAdapter<AzureBlobFSLocation, Model.DatasetLocation> {
    public _toResource(store: AzureBlobFSLocation): Model.ADLSGen2Location {
        const resource: Model.ADLSGen2Location = {
            type: this.model().name,
            fileName: ValueAdapter.toResource(store, AzureBlobFSLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, AzureBlobFSLocation.FOLDER_PATH) || undefined,
            // let's apply with datasetv2 doc to use fileSystem
            fileSystem: ValueAdapter.toResource(store, AzureBlobFSLocation.CONTAINER) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.ADLSGen2Location, owner: Named): AzureBlobFSLocation {
        const model = Owned.create<AzureBlobFSLocation>(this.model(), owner);
        ValueAdapter.toModel(model, AzureBlobFSLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, AzureBlobFSLocation.FOLDER_PATH, resource.folderPath);
        ValueAdapter.toModel(model, AzureBlobFSLocation.CONTAINER, resource.container);
        // currently copy wizard generate filesystem in blob fs location
        if (resource.fileSystem != null) {
            ValueAdapter.toModel(model, AzureBlobFSLocation.CONTAINER, resource.fileSystem);
        }
        return model;
    }

    protected model(): IModel {
        return AzureBlobFSLocation.MODEL;
    }
}
